module.exports = __webpack_public_path__ + "media/images/svgs/jobs/charts-347a3ada37481de5ecfa69de3bb511b0.svg";